// extracted by mini-css-extract-plugin
export default {"columnfooter":"columnfooter--9d5e8410","name":"name--6172a23f","resizer":"resizer--2676952f","menu":"menu--e2783e6c","dropdown":"dropdown--8ffbf04e"};